import React, {useCallback} from 'react';
import {useRemotionEnvironment} from '../get-environment.js';
// import {validateMediaProps} from '../validate-media-props.js';
// import {validateStartFromProps} from '../validate-start-from-props.js';
import {validateOffthreadVideoImageFormat} from '../validation/validate-offthreadvideo-image-format.js';
import {OffthreadVideoForRendering} from './OffthreadVideoForRendering.js';
import {VideoForDevelopment} from './VideoForDevelopment.js';

/**
 * @description This method imports and displays a video, similar to <Video />. During rendering, it extracts the exact frame from the video and displays it in an <img> tag
 *
 */
export const OffthreadVideo = (props) => {
	// Should only destruct `startFrom` and `endAt` from props,
	// rest gets drilled down
	const {startFrom, endAt, ...otherProps} = props;
	const environment = useRemotionEnvironment();

	const onDuration = useCallback(() => undefined, []);

	if (typeof props.src !== 'string') {
		throw new TypeError(
			`The \`<OffthreadVideo>\` tag requires a string for \`src\`, but got ${JSON.stringify(
				props.src
			)} instead.`
		);
	}

	if (typeof startFrom !== 'undefined' || typeof endAt !== 'undefined') {
		// validateStartFromProps(startFrom, endAt);

		const startFromFrameNo = startFrom ?? 0;

		// Pass startFrom directly to the underlying rendering component so it can
		// compute the correct file timestamp. No Sequence wrapper needed — the
		// parent scene Sequence already handles visibility clamping.
		if (environment === 'rendering') {
			return <OffthreadVideoForRendering {...otherProps} startFrom={startFromFrameNo} />;
		}

		return (
			<VideoForDevelopment
				onDuration={onDuration}
				onlyWarnForMediaSeekingError
				{...otherProps}
			/>
		);
	}

	// validateMediaProps(props, 'Video');
	validateOffthreadVideoImageFormat(props.imageFormat);

	if (environment === 'rendering') {
		return <OffthreadVideoForRendering {...otherProps} />;
	}

	return (
		<VideoForDevelopment
			onDuration={onDuration}
			onlyWarnForMediaSeekingError
			{...otherProps}
		/>
	);
};
